import { buildRefreshParameters, getTabularReducerInfo } from "./common"
import { apiGet, apiPut } from "../../utils/apiConnector"
import { purchaseApi } from "../../config/apiUrls"
import { forEachObjIndexed } from "ramda"
import { alertTypes, showMessage } from "../alerts"

// Thunk
export function refresh() {
  return (dispatch, getState) => {
    const state = getState()
    const storeId = state.profile.currentStore.id
    dispatch(actions.setLoading(true))

    apiGet(purchaseApi, buildRefreshParameters(storeId, state.purchases))
      .onOk((res) => {
        dispatch(
          actions.setData(
            res.data.response.purchases
              ? res.data.response.purchases.map((s) => ({
                  ...s,
                  id: s.purchaseId,
                  total: s.total,
                  items: s.items.map((i) => ({
                    ...i,
                    purchasePrice: i.price,
                  })),
                }))
              : [],
          ),
        )
        dispatch(actions.setTotalCount(res.data.response.count))
        dispatch(actions.setTotalPages(res.data.response.pages) || 1)
      })
      // .useDefaultErrorHandlers(dispatch)
      .onFail(() => {
        dispatch(actions.setData([]))
        dispatch(actions.setTotalCount(0))
        dispatch(actions.setTotalPages(1))
      })
      .onCancel(() => {
        dispatch(actions.setData([]))
        dispatch(actions.setTotalCount(0))
        dispatch(actions.setTotalPages(1))
      })
      .afterAll(() => {
        dispatch(actions.setLoading(false))
      })
      .startSingle()
  }
}

export function editPurchase(editedData) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    forEachObjIndexed((data, id) => {
      apiPut(purchaseApi + "/" + id, data)
        .onOk(() => {
          dispatch(refresh())
          dispatch(
            showMessage("Товар успешно отредактирован", alertTypes.success),
          )
        })
        .useDefaultErrorHandlers(dispatch)
        .start()
    }, editedData)
  }
}

const { actions, reducer, thunks } = getTabularReducerInfo("PURCHASES", refresh)
export default reducer
export const { openPage, filter, clear, search, sort, setDateRange } = thunks
